module.exports = __webpack_public_path__ + "img/img(11).05cd1af5.png";